function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icons/heart-fill-dark");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icons/heart-fill-dark",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "heart",
  transform: "translate(1.000000, 2.000000)",
  fill: "#4A4A4A",
  stroke: "#4A4A4A",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.84,2.61 C18.8084758,1.57799147 17.409138,0.998174379 15.95,0.998174379 C14.490862,0.998174379 13.0915242,1.57799147 12.06,2.61 L11,3.67 L9.94,2.61 C7.79161231,0.461612378 4.30838771,0.461612404 2.16000006,2.61000006 C0.0116124038,4.75838771 0.0116123778,8.24161231 2.16,10.39 L3.22,11.45 L11,19.23 L18.78,11.45 L19.84,10.39 C20.8720085,9.3584758 21.4518256,7.95913803 21.4518256,6.5 C21.4518256,5.04086197 20.8720085,3.6415242 19.84,2.61 Z",
  id: "Shape"
})));

var SvgHeartFillDark = function SvgHeartFillDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartFillDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-fill-dark.76c2831c.svg";
export { ForwardRef as ReactComponent };